/* eslint-disable */
export default {
	getAvailableOptionsWithinSelections,
	doesOptionExistWithinSelections,
	isOptionInStockWithinSelections,

	findVariant,
	getVariantFromUrl,
	getVariantFromUrlPrettyParameters,
	getFilterValuesFromVariant,

	slugify,
};

//	----------------------------------------------------
//	@param	Object	Shopify.Product
//	@param	Int		params.option_index					0,1,2
//	@return	Array	[<Strings>]							The OptionGroup's Possible Values
//	----------------------------------------------------
//	DEPRECATED: This has been replaced by 'getAvailableOptionsWithinSelections()'
/*
function getDistinctOptionValues(product,optionIndex){
	const optionValues = new Set();
	product.variants.forEach(_variant=>{
		const optionValue = _variant.selectedOptions[optionIndex]?.value;
		optionValues.add(optionValue);
	});//forEach
	return [...optionValues];
}
*/

//	----------------------------------------------------
//	@param	Object	Shopify.Product
//	@param	Int		Shopify.Product optionIndex				0,1,2
//	@param	Object	existingOptionSelections				{0:'string0',1:'string1',2:'string2'}
//	@param	Object	stockAvailabilityMap					{'hqlh3jkq2rhldq2h3af2==':3,'hafdsljksadjknlndlkas==':0}	A map of variant.storefrontId to variant.inventoryQuantity
//	@return	Array	A list of option.values that are available within the given 'optionIndexToLookIn'
//	----------------------------------------------------
function getAvailableOptionsWithinSelections(
	product,
	optionIndexToLookIn,
	existingOptionSelections,
	stockAvailabilityMap,
){
	//	Only look at applicable variants.
	const variants = product.variants
		.filter(
			filter_discardVariantsNotMatchingExistingSelections,
			{
				existingOptionSelections,
				optionIndexToLookIn,
			}
		)
		.filter(
			filter_discardVariantsNotInStock,
			{
				stockAvailabilityMap,
			}
		);

	//	Get Distinct Option Values within this Option Group
	const optionGroupValues = new Set();
	variants.forEach(function(_v){
		const optionValue = _v.selectedOptions[optionIndexToLookIn].value;
		optionGroupValues.add(optionValue);
	});

	//	Return
	return [...optionGroupValues];
}

//	----------------------------------------------------
//	@param	Object	Shopify.Product
//	@param	Int		Shopify.Product optionIndex				0,1,2
//	@param	String	Shopify.Product.Variant.option.value	'Burgundy'
//	@param	Object	existingOptionSelections				{0:'string0',1:'string1',2:'string2'}
//	@return	Bool	Whether or not the given option exists when the existing selections are applied.
//	----------------------------------------------------
function doesOptionExistWithinSelections(
	product,
	optionIndexToLookIn,
	optionValueToLookFor,
	existingOptionSelections,
) {
	const variants = product.variants
		.filter(
			filter_discardVariantsNotMatchingExistingSelections,
			{
				existingOptionSelections,
				optionIndexToLookIn,
			}
		)
		.filter(
			filter_discardVariantsNotContainingOurOptionValue,
			{
				optionIndexToLookIn,
				optionValueToLookFor,
			}
		);

	return !!variants.length;
}

//	----------------------------------------------------
//	@param	Object	Shopify.Product
//	@param	Int		Shopify.Product optionIndex				0,1,2
//	@param	String	Shopify.Product.Variant.option.value	'Burgundy'
//	@param	Object	existingOptionSelections				{0:'string0',1:'string1',2:'string2'}
//	@return	Bool	Whether or not the given option exists when the existing selections are applied.
//	----------------------------------------------------
function isOptionInStockWithinSelections(
	product,
	optionIndexToLookIn,
	optionValueToLookFor,
	existingOptionSelections,
	stockAvailabilityMap,
) {
	const variants = product.variants
		.filter(
			filter_discardVariantsNotMatchingExistingSelections,
			{
				existingOptionSelections,
				optionIndexToLookIn,
			}
		)
		.filter(
			filter_discardVariantsNotContainingOurOptionValue,
			{
				optionIndexToLookIn,
				optionValueToLookFor,
			}
		)
		.filter(
			filter_discardVariantsNotInStock,
			{
				stockAvailabilityMap,
			}
		);

	return !!variants.length;
}


//	---------------------------------------
//	@param	Object	Shopify.Product
//	@param	Object	A map of the selected variant options to match against
//	@return	Object	Shopify.Product.Variant
//	@return	Bool	false
//	---------------------------------------
function findVariant(product,filters){
	if (!product)	return false;

//	Get Selected Option Values
	const selected_option_values	=	Object.values(filters);

//	Find Variant with Matching Option Values
	const matching_variant	=	product.variants.find(_variant=>{
	//	Compare Each Option Value: Variant<=>Selected
	//	console.log('Comparing:',selected_option_values,_variant.options);	//	Debugging Only
		let _all_options_match	=	true;
		for(let _o=0; _o<product.options.length; _o++){	//	for instead of .forEach so we can 'break;' early.
		//	console.log('Comparing:',selected_option_values[_o],_variant.selectedOptions[_o].value);	//	Debugging Only
			if( selected_option_values[_o] != _variant.selectedOptions[_o].value ){
				_all_options_match	=	false;
				break;
			}//if
		}//for
		if(_all_options_match){
			return	true;
		}
		return false;
	});//forEach
	return matching_variant;
}//function


//	---------------------------------------
//	@param	Object	Shopify.Product
//	@return	Object	Shopify.Product.Variant
//	@return	null
//	---------------------------------------
function getVariantFromUrl(product) {
	if (typeof window !== 'undefined') {
		const urlParameters	=	new URLSearchParams(window.location.search);
		const urlVariantId	=	urlParameters.get('variant');
		if (urlVariantId) {
			const urlVariantGid	=	`gid://shopify/ProductVariant/${ urlVariantId }`;
			const urlVariantStorefrontId	=	btoa(urlVariantGid);
			// eslint-disable-next-line eqeqeq
			const urlVariant = product.variants.filter(_v => { return _v.storefrontId == urlVariantStorefrontId; }).pop();
			return urlVariant;
		}
	}
	return null;
}

//	---------------------------------------
//	@param	Object	Shopify.Product
//	@return	Object	Shopify.Product.Variant
//	@return	null
//	---------------------------------------
function getVariantFromUrlPrettyParameters(product) {
	if (typeof window !== 'undefined') {
		const urlParameters	=	new URLSearchParams(window.location.search);
		const matchingVariants = product.variants.filter(variant => {
			//	If we can find an option in this variant that doesn't match the URL parameter(s)
			//	then this variant doesn't match; meaning we must return false to the filter.
			return !variant.selectedOptions.find(option => {
				//	Compare the variant's option value to that defined in the URL
				return slugify(option.value) !== urlParameters.get(slugify(option.name));
			});
		});
		return matchingVariants.pop() || getVariantFromUrl(product);
	}
	return null;
}

//	---------------------------------------
//	@param	Object	Shopify.Product.Variant
//	@return	Object	Filters
//	@return	String	Filters[0]	The option0 value to match against Product.variants
//	@return	String	Filters[1]	The option1 value to match against Product.variants
//	@return	String	Filters[2]	The option2 value to match against Product.variants
//	---------------------------------------
function getFilterValuesFromVariant(variant) {
	const filters = {};
	if (!variant?.selectedOptions)	return filters;	//	Breakpoint
	variant.selectedOptions.forEach((option, i) => {
		filters[i] = option.value;
	});
	return filters;
}


//	----------------------
//	Variant Filter Helpers
//	----------------------

//	Discard any variants that don't match our existing option selections
function filter_discardVariantsNotMatchingExistingSelections(_variant) {
	const {
		existingOptionSelections,
		optionIndexToLookIn,
	} = this;

	let allSelectionsMatch = true;
	//	Loop over the option group indexes selected so far
	//	for instead of .forEach so we can 'break;'.
	for( let optionGroupIndex in existingOptionSelections ){
		//	Skip the optionGroup we're already a part of
		//	because we want the user to be able to choose other options within this group.
		//	Obviously discarding any option in this group that doesn't match would prevent them from doing that.
		if (optionGroupIndex == optionIndexToLookIn) continue;

		//	Check if this variant's option@sameGroupIndex matches the selection@sameGroupIndex
		let selectedValueWithinOptionGroup	=	existingOptionSelections[optionGroupIndex].toLowerCase();
		let variantValueAtOptionIndex		=	_variant.selectedOptions[optionGroupIndex].value.toLowerCase();
		if( selectedValueWithinOptionGroup != variantValueAtOptionIndex ){
			allSelectionsMatch	=	false;
			break;
		}//if
	}//for

	return allSelectionsMatch;
}

//	Discard any variants that don't contain our optionValue
function filter_discardVariantsNotContainingOurOptionValue(_variant) {
	const {
		optionIndexToLookIn,
		optionValueToLookFor,
	} = this;

	const variantValueAtOptionIndex		=	_variant.selectedOptions[optionIndexToLookIn].value.toLowerCase();
	const variantContainsThisOptionValue = variantValueAtOptionIndex == optionValueToLookFor.toLowerCase();
	return variantContainsThisOptionValue;
}

//	Discard any variants that aren't inStock
function filter_discardVariantsNotInStock(_variant) {
	const {
		stockAvailabilityMap,
	} = this;

	const variantIsInStock = 0 < stockAvailabilityMap[btoa(_variant.storefrontId)];
	return variantIsInStock;
}

//	-------------------
//	String Manipulation
//	-------------------
function slugify(string='') {
	return string.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-');
}
